import { render } from "./PropertyChooser.vue?vue&type=template&id=cd3739ae&scoped=true"
import script from "./PropertyChooser.vue?vue&type=script&lang=js"
export * from "./PropertyChooser.vue?vue&type=script&lang=js"

import "./PropertyChooser.vue?vue&type=style&index=0&id=cd3739ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3739ae"]])

export default __exports__